import { useEffect } from 'react';
import { loadExportHistory } from './loadTelemetry';
import downloadStore from './store';

/**
 * Loads export history while enabled, and clears the shared store on cleanup.
 * A disabled hook leaves the store alone, because ExportHistory owns it then.
 */
export function useLoadExportHistory(projectId: string, enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;

    void loadExportHistory(projectId, 'initial');

    return () => downloadStore.reset();
  }, [projectId, enabled]);
}
